<div *ngIf="!confirm && canCancel">
	<div class="text-center">
		<h4>Are you sure you want to cancel order?</h4>
		<p>All details tied to your active order will be lost</p>
	</div>

	<div class="flex justify-center items-center mt-5 gap-4">
		<app-button btn="tertiary" (click)="close()" size="small">No</app-button>
		<app-button btn="primary" (click)="setConfirm()" size="small"
			>Yes</app-button
		>
	</div>
</div>

<div *ngIf="confirm">
	<form
		#form="ngForm"
		class="flex flex-col items-center justify-center gap-5"
		(ngSubmit)="cancel(form)"
	>
		<h4>Confirm cancellation</h4>
		<p>
			Please provide a reason for the cancellation to be provided to Chicago
			Title
		</p>
		<app-dropdown
			name="cancelValue"
			[required]="true"
			class="w-full px-10"
			label="Cancellation reason"
			[itemGroups]="cancelOptions"
			[ngModel]="cancelValue"
			(onSelect)="selectCode($event)"
			[submitted]="submitted"
		></app-dropdown>
		<app-text-area
			name="cancelText"
			[required]="true"
			class="w-full px-10"
			*ngIf="cancelCode === 13"
			label="Additional details"
			[(ngModel)]="cancelText"
			[submitted]="submitted"
		></app-text-area>
		<div class="flex justify-between items-center mt-10">
			<app-button btn="tertiary" (click)="close()" type="submit" size="small"
				>Cancel</app-button
			>
			<app-button [loading]="loading" btn="primary" type="submit" size="small"
				>Confirm</app-button
			>
		</div>
	</form>
</div>

<div *ngIf="!confirm && !canCancel">
	<div class="text-center">
		<h4>Escalation required</h4>
		<p>
			As the closing date of your file has passed, you must contact Chicago
			Title directly to request the cancellation of your order. Initiate your
			request via the details below:
		</p>
		<div class="mx-auto w-32 h-32 my-5">
			<img src="/assets/images/integrations/chicago-title-logo.svg" />
		</div>
		<div class="flex flex-col gap-4 items-center justify-center">
			<div>
				<app-icon [icon]="ICON.PHONE" class="text-grey-light mr-3"></app-icon>
				<span class="hover:text-green hover:underline"
					><a
						externalNavInterceptor
						href="tel:{{ 888 - 868 - 4583 }}"
						target="_blank"
						>(888) 868-4853</a
					></span
				>
			</div>
			<div>
				<app-icon [icon]="ICON.EMAIL" class="text-grey-light mr-3"></app-icon>
				<span class="hover:text-green hover:underline"
					><a emailLinkInterceptor href="mailto:info@chicagotitle.ca"
						>info&#64;chicagotitle.ca</a
					>
				</span>
			</div>
		</div>
	</div>
	<div class="flex justify-center items-center mt-5">
		<app-button btn="secondary" (click)="close()" size="small"
			>Close</app-button
		>
	</div>
</div>
